﻿import { message } from "./antdMessageBridge";

export const exportToCSV = (data, columns, filename) => {
    // Failsafe: Don't attempt to download if there's no data
    if (!data || data.length === 0) {
        console.warn("No data provided for CSV export");
        message.warning("The grid is currently empty. There are no records to export");
        return;
    }

    // 1. Get valid columns (must have both a title and a dataIndex)
    const validColumns = columns.filter((col) => col && col.title && col.dataIndex);
    const headers = validColumns.map((col) => col.title).join(",");

    // 2. Map Rows to CSV format
    const csvRows = data.map((row) =>
        validColumns.map((col) => {
            const value = row[col.dataIndex] !== null && row[col.dataIndex] !== undefined ? row[col.dataIndex] : "";
            // Wrap in quotes and escape internal quotes to prevent layout breakage
            return `"${String(value).replace(/"/g, '""')}"`;
        }).join(",")
    );

    // 3. Combine and generate Blob
    // ─── CRITICAL FIX: Added "\uFEFF" (Byte Order Mark) to force UTF-8 in Excel ───
    const csvString = "\uFEFF" + [headers, ...csvRows].join("\n");

    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // 4. Trigger Native Download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // 5. Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};